import React from "react";
import "./LoadingComponent.css"; // Add styling

const LoadingComponent = ({ message }) => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <h2 className="loading-message">{message}</h2>
    </div>
  );
};

export default LoadingComponent;
